export default __webpack_public_path__ + "static/media/030-life-jacket.2f7f500c.png";